<script setup>
// Editor de e-mail drag-drop profissional (GrapesJS + preset newsletter), 100%
// no nosso servidor (sem serviço externo). Upload de imagem vai pro nosso storage
// (uploadFile). Exporta HTML email-safe (CSS inline) via `gjs-get-inlined-html`.
// Blocos extras da EMPRESA: logo (imagem que o cliente sobe pelo asset manager)
// + rodapé com {{remetente}}/{{endereco}} (dados do remetente, resolvidos no envio).
import { ref, onMounted, onBeforeUnmount } from 'vue';
import grapesjs from 'grapesjs';
import presetNewsletter from 'grapesjs-preset-newsletter';
import 'grapesjs/dist/css/grapes.min.css';
import { uploadFile } from 'dashboard/helper/uploadHelper';

const props = defineProps({
  design: { type: Object, default: null },
});

const container = ref(null);
let editor = null;

function addCompanyBlocks(ed) {
  const bm = ed.BlockManager;
  bm.add('company-logo', {
    label: 'Logo',
    category: 'Empresa',
    // Imagem: o cliente dá duplo-clique e sobe a logo dele (asset manager → nosso storage).
    content: {
      type: 'image',
      style: {
        'max-width': '180px',
        height: 'auto',
        display: 'block',
        margin: '0 auto 16px',
      },
    },
  });
  bm.add('company-footer', {
    label: 'Rodapé',
    category: 'Empresa',
    // {{remetente}} e {{endereco}} = dados da empresa do cliente (resolvidos no envio).
    content:
      '<div style="font-family:Arial,sans-serif;font-size:12px;color:#888888;text-align:center;padding:16px 0;border-top:1px solid #eeeeee;margin-top:24px">{{remetente}}<br/>{{endereco}}</div>',
  });
}

async function handleUpload(event) {
  const files = event.dataTransfer
    ? event.dataTransfer.files
    : event.target.files;
  const added = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const file of Array.from(files || [])) {
    // eslint-disable-next-line no-await-in-loop
    const res = await uploadFile(file);
    if (res?.fileUrl) added.push({ src: res.fileUrl, name: file.name });
  }
  if (added.length) editor.AssetManager.add(added);
}

onMounted(() => {
  editor = grapesjs.init({
    container: container.value,
    // Altura concreta: dentro do SettingsWrapper o height:100% não resolve e o
    // canvas ficava com 0px (barra aparecia, área de edição não).
    height: 'calc(100vh - 110px)',
    fromElement: false,
    storageManager: false,
    plugins: [ed => presetNewsletter(ed, {})],
    assetManager: { uploadFile: handleUpload },
  });

  addCompanyBlocks(editor);

  if (props.design && Object.keys(props.design).length) {
    try {
      editor.loadProjectData(props.design);
    } catch {
      // design antigo/incompatível — começa em branco
    }
  }
});

onBeforeUnmount(() => {
  editor?.destroy();
  editor = null;
});

function getContent() {
  const html = editor.runCommand('gjs-get-inlined-html') || editor.getHtml();
  return { html, design: editor.getProjectData() };
}

defineExpose({ getContent });
</script>

<template>
  <div ref="container" class="w-full h-full" />
</template>
